import { usePostHog } from "posthog-js/react";
import { Link, useLocation } from "react-router-dom";

const MoodLink = (props) => {
  const posthog  = usePostHog();
  const location = useLocation();
  const _props   = { ...props };
  if ( _props.to.startsWith('https://hellomood.co') ) {
    _props.to += _props.to.indexOf('?') === -1 ? location.search : location.search.replace('?', '&');
  }

  const phClick = () => {
    posthog.capture('link clicked');
    console.log('Link clicked');
  };

  return (
    <Link {..._props} onClick={phClick} />
  )
};

export default MoodLink;